import type { DeliveryLocation, MenuType } from '@/lib/types'

export type FixedDeliveryLocation = Pick<DeliveryLocation, 'id' | 'eatInEnabled' | 'takeAwayEnabled'>

export function selectDeliveryLocation(locations: DeliveryLocation[], menuType: MenuType, fixed: FixedDeliveryLocation | null) {
  const compatible = (location: FixedDeliveryLocation) => (menuType === 'EatIn' ? location.eatInEnabled !== false : location.takeAwayEnabled !== false)
  const available = locations.filter(compatible)
  const preferred = menuType === 'TakeAway' && fixed && compatible(fixed) ? available.find((location) => location.id === fixed.id) : undefined
  return { locations: available, selectedId: preferred?.id ?? available[0]?.id ?? '' }
}
